import cx from 'classnames';
import CustomSelect from '../../../CustomSelect/CustomSelect';
import FormField from '../../../form-field/FormField';
import { IRangeDates } from '../../../month-range-picker-with-options/model/types/IRangeDates';
import { useFilterPanelContext } from '../../context/FilterPanelContext';
import filterPanelStyles from '../../FilterPanel.module.scss';
import { FilterField } from '../../types';
import { CSSProperties } from 'react';

interface IProps {
  field: FilterField;
  style?: CSSProperties;
}

const SelectField = ({ field, style }: IProps) => {
  const { values, setValues, setAutocomplete } = useFilterPanelContext();

  const customSelectOptions = (field.options || []).map((opt) => ({
    id: opt?.value || '',
    name: opt?.label || '',
    value: opt?.value || '',
  }));

  const handleChange = (
    key: string,
    value: string | [string, string] | IRangeDates
  ) => {
    setValues({ ...values, [key]: value });
    if (typeof value === 'string') {
      setAutocomplete((prev) => ({ ...prev, [key]: value }));
    }
  };

  return (
    <div
      key={field.key}
      className={cx(filterPanelStyles.filterItem, field.className)}
      tabIndex={0}
      style={style}
    >
      <FormField label={field.label}>
        <CustomSelect
          key={field.key}
          // className={cx(style.filterItem, field.className)}
          options={customSelectOptions}
          value={values[field.key] as string}
          onOptionChange={(option) => handleChange(field.key, option.value)}
          placeholder="Выбрать"
          disabled={field.disabled}
          isUseInput
        />
      </FormField>
    </div>
  );
};

export default SelectField;
